import { Component } from '@angular/core';

@Component({
  selector: 'hub-page-not-found',
  standalone: true,
  imports: [],
  template: `
    <div class="tw-flex tw-items-center tw-justify-center tw-h-[70vh] tw-gap-4">
      <h1>404</h1>
      <span>|</span>
      <p>Página não encontrada</p>
    </div>
  `,
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {}
